import React, { forwardRef, useMemo } from 'react'
import AllResourceTabTables from './AllResourceTabTables'
import { PageConfig } from '@configure/PathConfig'

const TabTable = forwardRef(({
  currentTab,
  currentTabIndex,
  tabValueCounts,
  setTabValueCounts,
  filteredPeople,
  selectedTab,
  profileData,
  onExport,
  forwardref,
  refreshData,
  notesLoader,
  isAuthenticated,
  columnVisibility,
  setColumnVisibility,
  setRefData=()=>null
}) => {
  const commonProps = useMemo(() =>  {
    return{
    id: "tableallresourcestable",
    currentTabIndex,
    currentTab,
    setTabValueCounts,
    filteredPeople,
    profileData,
    onclickRoute: `${PageConfig["RM"].PROFILE}`,
    onExport,
    isAuthenticated : isAuthenticated,
    refreshData,
    notesLoader,
    columnVisibility,
    setColumnVisibility,
    setRefData
  }
  },[currentTab,currentTabIndex,filteredPeople,isAuthenticated,profileData,notesLoader,JSON.stringify(columnVisibility)])

  const allTabs = useMemo(() => [
    {
      key: "all_resources",
      label: "All Resources",
      content: (
        <AllResourceTabTables
          {...commonProps}
          tabValueCounts={tabValueCounts?.total_res_count || 0}
          key="all_resources"
          name="all_resources"
          ref={forwardref}
        />
      ),
    },
    {
      key: "manager",
      label: "Manager",
      content: (
        <AllResourceTabTables
          {...commonProps}
          tabValueCounts={tabValueCounts?.manager_res_count || 0}
          key="manager"
          name="manager"
          ref={forwardref}
        />
      ),
    },
    {
      key: "inprojects",
      label: "In Projects",
      content: (
        <AllResourceTabTables
          {...commonProps}
          tabValueCounts={tabValueCounts?.in_proj_res_count || 0}
          key="inprojects"
          name="inprojects"
          ref={forwardref}
        />
      ),
    },
    {
      key: "inbench",
      label: "In Bench",
      content: (
        <AllResourceTabTables
          {...commonProps}
          tabValueCounts={tabValueCounts?.inbench_res_count || 0}
          key="inbench"
          name="inbench"
          ref={forwardref}
        />
      ),
    },
    {
      key: "approach_bench",
      label: "Approach Bench",
      content: (
        <AllResourceTabTables
          {...commonProps}
          tabValueCounts={tabValueCounts?.appr_bench_res_count || 0}
          key="approach_bench"
          name="approach_bench"
          ref={forwardref}
        />
      ),
    },
    {
      key: "full_time_employee",
      label: "Full Time Employee",
      content: (
        <AllResourceTabTables
          {...commonProps}
          tabValueCounts={tabValueCounts?.full_time_res_count || 0}
          key="full_time_employee"
          name="full_time_employee"
          ref={forwardref}
        />
      ),
    },
    {
      key: "contractor",
      label: "Contractor",
      content: (
        <AllResourceTabTables
          {...commonProps}
          tabValueCounts={tabValueCounts?.contractor_res_count || 0}
          key="contractor"
          name="contractor"
          ref={forwardref}
        />
      ),
    },
    {
      key: "leadership",
      label: "Leadership",
      content: (
        <AllResourceTabTables
          {...commonProps}
          tabValueCounts={tabValueCounts?.ldrshp_res_count || 0}
          key="leadership"
          name="leadership"
          ref={forwardref}
        />
      ),
    },
    {
      key: "india_people",
      label: "India People",
      content: (
        <AllResourceTabTables
          {...commonProps}
          tabValueCounts={tabValueCounts?.india_res_count || 0}
          key="india_people"
          name="india_people"
          ref={forwardref}
        />
      ),
    },
    {
      key: "us_people",
      label: "US People",
      content: (
        <AllResourceTabTables
          {...commonProps}
          tabValueCounts={tabValueCounts?.us_res_count || 0}
          key="us_people"
          name="us_people"
          ref={forwardref}
        />
      ),
    },
    {
      key: "canada_people",
      label: "Canada People",
      content: (
        <AllResourceTabTables
          {...commonProps}
          tabValueCounts={tabValueCounts?.can_res_count || 0}
          key="canada_people"
          name="canada_people"
          ref={forwardref}
        />
      ),
    },
  ],[currentTab,currentTabIndex,filteredPeople,isAuthenticated,profileData,notesLoader,JSON.stringify(columnVisibility)])

  // now match by key (not label)
  const activeTab = useMemo(() => allTabs.find((tab) => tab.key === selectedTab?.key),[allTabs,selectedTab?.key])

  return activeTab ? activeTab.content : null
})

export default TabTable
